import { useIntegrationSelectOptions } from "components/UI/Selects/IntegrationSelectSearchable/useIntegrationSelectOptions.ts";
import { SearchableSelect, SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const IntegrationSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useIntegrationSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.integrations"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};